import { render } from "./MainScripts.vue?vue&type=template&id=736c0fa0&scoped=true"
import script from "./MainScripts.vue?vue&type=script&lang=js"
export * from "./MainScripts.vue?vue&type=script&lang=js"

import "./MainScripts.vue?vue&type=style&index=0&id=736c0fa0&scoped=true&lang=css"

import exportComponent from "/home/rainnya_lime/桌面/project/waydro.id/Waydro.id/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736c0fa0"]])

export default __exports__